import { render, staticRenderFns } from "./ProposalTable.vue?vue&type=template&id=4e819700"
import script from "./ProposalTable.vue?vue&type=script&lang=js"
export * from "./ProposalTable.vue?vue&type=script&lang=js"
import style0 from "./ProposalTable.vue?vue&type=style&index=0&id=4e819700&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports